import * as React from 'react';

import { Tag } from 'baseui/tag';

const Badge = props => (
  <Tag
    onClick={props.onClick}
    closeable={false}
    kind='custom'
    variant='light'
    color='rgb(197, 206, 222)'
    overrides={{
      Root: {
        style: ({ $isHovered }) => ({
          backgroundColor: $isHovered
            ? 'rgba(197, 206, 222, 0)'
            : 'rgba(197, 206, 222, 0)',
        }),
      },
      Text: {
        style: ({ $isHovered }) => ({
          color: $isHovered ? 'rgb(197, 206, 222)' : 'rgb(197, 206, 222)',
        }),
      },
    }}
  >
    Idle
  </Tag>
);

export default Badge;
